// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","channelLink":"Footer_channelLink__p-6he","textContent":"Footer_textContent__TywXa","footerImg":"Footer_footerImg__Ne5pT"};